import SpatialAdjustEntityType = ToroEnums.SpatialAdjustEntityType;

import { IotRequestParams } from './iot-request-params.model';
import { ToroEnums } from '../../../common/enumerations/toro.enums';

export class IotChangePercentAdjustParams extends IotRequestParams {

    constructor(json: any = null) {
        super(json?.installationId, json?.siteId);

        if (json) {
            Object.assign(this, json);
        }
    }

    ids: number[];
    entityType: SpatialAdjustEntityType;
    percentAdjust: number;
}
